// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3sAth","closeContainer":"QdgN-","heading":"_3jPaD","expiredImage":"_31RBp","subHeading":"_3tyxc"};